import { AuxButton } from "@blk/aladdin-react-components-es";
import { AuxButtonTypeEnum, AuxButtonSizeEnum } from "@blk/aladdin-web-components";
import React from "react";
import { batch, useDispatch, useSelector } from "react-redux";
import { exportBenchmarkSettings } from "./exportBenchmarkSettings";
import { MessagesDialogFunctionName } from "./helper";
import { useGetUnitOfAreaKey, useGetUserAllocationKey, useGetUserCommitmentCalculation } from "./hooks/use-user-preferences";
import { importBenchmarkSettings } from "./importBenchmarkSettings";
import { usePostBenchmarksConfiguration } from "api/admin/src";
import { EntityType } from "api/ux/src";
import { ModalName } from "components/modal/types";
import { InsUploadButton } from "components/pages/administration/common/insUploadButton";
import { useCurrentDashboardCurrency, useCurrentDashboardOptions } from "components/workspaces/hooks/use-current-dashboard";
import { allocationKeyEnumValues, unitOfAreaKeyEnumValue } from "hooks/widget-data/use-datapoints";
import { language } from "language/default";
import { setBenchmarkMode } from "store/grid-settings";
import { removeAllSelectedRow } from "store/grids";
import { setMessagesDialog } from "store/messages-dialog";
import { openModal } from "store/modal";
export const InsFundsHeaderLeftBenchmark = (props) => {
    const [, mutation] = usePostBenchmarksConfiguration();
    const dispatch = useDispatch(), selectedRows = useSelector((state) => state.grids.state[props.stateId]?.selectedRows);
    const dashboardOptions = useCurrentDashboardOptions();
    const allocationKey = allocationKeyEnumValues(useGetUserAllocationKey());
    const commitmentCalculation = useGetUserCommitmentCalculation();
    const unitOfArea = unitOfAreaKeyEnumValue(useGetUnitOfAreaKey());
    const currency = useCurrentDashboardCurrency();
    return React.createElement("div", { className: "insFundsHeaderLeft" },
        React.createElement(AuxButton, { isDisabled: !selectedRows || selectedRows.length === 0, onClick: () => {
                dispatch(openModal({
                    content: {
                        id: "privateBenchmark",
                        modalName: ModalName.BenchmarkList,
                        parameters: { ids: selectedRows, type: EntityType.Fund.toLocaleLowerCase() }
                    },
                    title: language.en.modal.privateBenchmarkSelection.title,
                    type: "action"
                }));
            }, type: AuxButtonTypeEnum.SECONDARY, label: language.en.funds.benchmark.setBenchmark }),
        React.createElement(AuxButton, { isDisabled: !selectedRows || selectedRows.length === 0, onClick: () => {
                dispatch(setMessagesDialog({ functionName: MessagesDialogFunctionName.ResetBenchmark,
                    messages: [
                        { message: language.en.funds.benchmark.resetBenchmarkAlertFirstLine },
                        { message: language.en.funds.benchmark.resetBenchmarkAlertSecondLine }
                    ],
                    title: language.en.funds.benchmark.resetBenchmarkHeader,
                    type: "alert-with-options" }));
            }, type: AuxButtonTypeEnum.SECONDARY, label: language.en.funds.benchmark.resetBenchmark }),
        React.createElement(AuxButton, { onClick: () => exportBenchmarkSettings(dispatch, props.stateId === "all-InvestorAccount-grid", allocationKey, unitOfArea, commitmentCalculation, currency, dashboardOptions), className: "insFundsHeaderLeftTertiaryButton", icon: "download", type: AuxButtonTypeEnum.SECONDARY, label: language.en.funds.benchmark.exportBenchmarkConfiguration }),
        React.createElement(InsUploadButton, { accept: ".xls,.xlsx", label: language.en.funds.benchmark.importBenchmerkConfiguration, buttonSize: AuxButtonSizeEnum.REGULAR, buttonType: AuxButtonTypeEnum.SECONDARY, buttonClassName: "insFundsHeaderLeftTertiaryButton", onChanged: async (e) => {
                await importBenchmarkSettings(props.stateId === "all-InvestorAccount-grid", e, mutation, dispatch);
            } }),
        React.createElement(AuxButton, { className: "insFundsHeaderLeftTertiaryButton", icon: "delete", type: AuxButtonTypeEnum.TERTIARY, label: language.en.funds.benchmark.closeBenchmark, onClick: () => batch(() => {
                dispatch(setBenchmarkMode(false));
                dispatch(removeAllSelectedRow(props.stateId));
            }) }));
};
